// @ts-nocheck
import * as Types from '../../@types/apiql.generated.d';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type TAvatarsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type TAvatarsQuery = { __typename?: 'Query', viewer: { __typename?: 'Viewer', profileAvatars: Array<{ __typename?: 'AvatarType', group: string, imageUrl: string, name: string }> } };


export const AvatarsDocument = gql`
    query Avatars {
  viewer {
    profileAvatars {
      group
      imageUrl
      name
    }
  }
}
    `;

/**
 * __useAvatarsQuery__
 *
 * To run a query within a React component, call `useAvatarsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvatarsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvatarsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAvatarsQuery(baseOptions?: Apollo.QueryHookOptions<TAvatarsQuery, TAvatarsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TAvatarsQuery, TAvatarsQueryVariables>(AvatarsDocument, options);
      }
export function useAvatarsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TAvatarsQuery, TAvatarsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TAvatarsQuery, TAvatarsQueryVariables>(AvatarsDocument, options);
        }
export type AvatarsQueryHookResult = ReturnType<typeof useAvatarsQuery>;
export type AvatarsLazyQueryHookResult = ReturnType<typeof useAvatarsLazyQuery>;
export type AvatarsQueryResult = Apollo.QueryResult<TAvatarsQuery, TAvatarsQueryVariables>;